/** A45: ряд «Чайная · МК · Такси» — дословный порт ячеек макета (v41):
 *  чайная в две компактные строки (чашка-квадратик + комната / имена убиравших,
 *  клик по строке = её дропдаун, «Без чайной» — пункт списка комнат), МК ✕/5.0
 *  два состояния, такси — шашечки + сумма с автоужатием шрифта. У напарника — только
 *  такси, а у игры с Мира Квестов (10.10) — МК + такси. */
import type { RefObject } from "react";
import type { OperatorOption } from "../../hooks/useOperatorsList";
import type { PadOpen } from "./reportFields";
import m from "./opReport.module.css";
import css from "./reports.module.css";

export function TripleRow({ partner, isMirkv, teaActive, setTeaActive, teaRoomName, teaRoomOpen, setTeaRoomOpen, teaRooms, setTeaRoomId, cleaners, setCleaners, cleanerOpen, setCleanerOpen, operators, taxi, setTaxi, mkStatus, setMkStatus, mkInvalid, mkRef, pad }: {
  partner: boolean; isMirkv: boolean;
  /** 10.10 (владелец): МК-отметку ставит КАЖДЫЙ оператор (и напарник) — без отметки отчёт не уходит, графа краснеет */
  mkInvalid?: boolean; mkRef?: RefObject<HTMLElement | null>;
  teaActive: boolean; setTeaActive: (v: boolean) => void;
  teaRoomName: string | null; teaRoomOpen: boolean; setTeaRoomOpen: (f: (o: boolean) => boolean) => void;
  teaRooms: { id: string; name: string }[]; setTeaRoomId: (id: string) => void;
  cleaners: OperatorOption[]; setCleaners: (c: OperatorOption[]) => void;
  cleanerOpen: boolean; setCleanerOpen: (f: (o: boolean) => boolean) => void;
  operators: OperatorOption[];
  taxi: number; setTaxi: (v: number) => void;
  mkStatus: string; setMkStatus: (s: string) => void;
  pad: PadOpen;
}) {
  const tx = Math.round(taxi);
  const cols = partner ? (isMirkv ? "0.9fr 0.68fr" : "1fr") : "1.55fr 0.9fr 0.68fr";
  return (
    <div className={m.triple} style={{ gridTemplateColumns: cols }}>
      {!partner ? (
        <section className={`${m.hud} ${m.blue} ${m.cell} ${m.tea} ${teaActive ? m.on : ""}`} data-tip="Чайная: комната и кто убирал">
          <span className={m.teacol}>
            <span className={m.teasel2} onClick={() => { setTeaRoomOpen((o) => !o); setCleanerOpen(() => false); }}>
              <span className={m.cupbox2}><svg className={m.cup} viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="square" aria-hidden="true"><path d="M2 5h8v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5z" /><path d="M10 6h1.5a1.5 1.5 0 0 1 0 3H10" /><path d="M5 2v1M7 2v1" /></svg></span>
              <span className={m.rmName}>{teaActive ? (teaRoomName ?? "Чайная") : "Без чайной"}</span>
            </span>
            <button type="button" className={`${m.clrow} ${cleaners.length ? "" : m.empty}`} title="Кто убирал чайную"
              onClick={() => { setCleanerOpen((o) => !o); setTeaRoomOpen(() => false); }}>
              <span className={m.clNames}>{cleaners.length ? cleaners.map((c) => c.name).join(", ") : "кто убирал?"}</span>
            </button>
          </span>
          {teaRoomOpen ? (
            <div className={`${css.cyberPop} ${css.popDown} ${css.open} ${m.teaPop}`}>
              <button type="button" className={css.popItem} onClick={() => { setTeaActive(false); setTeaRoomOpen(() => false); }}>Без чайной</button>
              {teaRooms.map((r) => (
                <button key={r.id} type="button" className={css.popItem} onClick={() => { setTeaActive(true); setTeaRoomId(r.id); setTeaRoomOpen(() => false); }}>{r.name}</button>
              ))}
            </div>
          ) : null}
          {cleanerOpen ? (
            <div className={`${css.cyberPop} ${css.popDown} ${css.open} ${m.teaPop}`}>
              {cleaners.map((c) => (
                <button key={c.id} type="button" className={css.popItem} onClick={() => setCleaners(cleaners.filter((x) => x.id !== c.id))}>
                  <span style={{ color: "var(--red)" }}>✕ </span>{c.name}
                </button>
              ))}
              {operators.filter((o) => !cleaners.some((c) => c.id === o.id)).map((o) => (
                <button key={o.id} type="button" className={css.popItem} onClick={() => setCleaners([...cleaners, o])}>+ {o.name}</button>
              ))}
            </div>
          ) : null}
        </section>
      ) : null}
      {!partner || isMirkv ? (
        <section ref={mkRef} className={`${m.hud} ${m.mk2} ${m.cell} ${m.two} ${mkStatus ? m.live : ""} ${isMirkv ? "" : m.mkOff} ${mkInvalid ? m.mkNeed : ""}`}
          data-tip="Мир Квестов: отменили / оценки" aria-disabled={!isMirkv}>
          <button type="button" className={`${m.mkx} ${mkStatus === "cancel" ? m.on : ""}`} title="МК: отменили" disabled={!isMirkv} onClick={() => setMkStatus(mkStatus === "cancel" ? "" : "cancel")}>✕</button>
          <button type="button" className={`${m.mk5} ${mkStatus === "score" ? m.on : ""}`} title="МК: оценки" disabled={!isMirkv} onClick={() => setMkStatus(mkStatus === "score" ? "" : "score")}>5.0</button>
        </section>
      ) : null}
      <section className={`${m.hud} ${m.taxi2} ${m.cell} ${m.two} ${taxi > 0 ? m.live : ""}`} title="Такси оператора"
        onClick={(e) => pad(e.currentTarget, "Такси", taxi, setTaxi)}>
        <span className={m.checker} />
        <span className={`${m.taxiv} ${tx >= 10000 ? m.d5 : tx >= 1000 ? m.d4 : ""}`}><span className={m.rub}>₽</span><span className={m.sum}>{tx}</span></span>
      </section>
    </div>
  );
}
